import * as React from 'react';

const EmptyInvoiceLinesList = ({ show }): JSX.Element | null => {
  return show && <div className="no-items-selected">Please select an invoice.</div>;
};

export default EmptyInvoiceLinesList;
